import React from 'react';
import './CompanyStrategy.css';

function ProcurementSOP() {
  return (
    <div className="document-section">
      <h2>Procurement SOP</h2>
      <iframe
        src="/pdfs/nesim-procurement-sop-final.pdf"
        title="Procurement SOP Final"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
}

export default ProcurementSOP;
